import Sorting from "./components/Sorting";
import Sorting2 from "./components/Sorting2";
import HelloWorld from "./components/HelloWorld";

export const routes = [
    { path: "/", component: Sorting },
    { path: "/vuejs-demo", component: Sorting },
    { path: "/menu2", component: Sorting2},
    { path: "/menu3", component: HelloWorld}
]